import theme from 'assets/theme';

export const REPORT_COLORS = {
  BLUE: '#DAF3FF',
  YELLOW: '#FFFECF',
  DARK_YELLOW: '#FFF59D',
  GREEN: '#E8FFF2',
  NEUTRAL: theme.palette.grey[200],
  WHITE: theme.palette.common.white,
  BORDER: 'rgb(224 224 224)',
  UNSAVED_BACKGROUND_COLOR: '#FEF4E5',
  DISCREPANCY_BACKGROUND_COLOR: '#FFF59D',
  NEW_BACKGROUND_COLOR: '#D4EDDA',
  OLD_BACKGROUND_COLOR: '#F8D7DA',
  HARD_COST_SUBTOTAL_COLOR: '#DAF3FF',
  PROJECTED_HARD_COST_SUBTOTAL_COLOR: '#DAF3FF',
  SOFT_COST_SUBTOTAL_COLOR: '#FFE6E4',
  TOTAL_COST_COLOR: '#E9FFF2',
  COMPS_TABLE_COLOR: theme.palette.grey[200],
  PAYAPP_ONLY_BACKGROUND_COLOR: '#BBD4EC',
  PROJECT_ONLY_BACKGROUND_COLOR: '#ECE0F7',
  PAYAPP_PROJECT_MISMATCH_BACKGROUND_COLOR: 'rgb(255 235 237)',
  PAYAPP_PROJECT_MISMATCH_BORDER_COLOR: theme.palette.error.main,
  ADJUSTMENT_COLOR: '#9e9e9e',
  COMP_PRICING_COLOR: theme.palette.primary.main,
  ALLOWANCE_COLOR: '#0283a0',
  HIGHLIGHT_BACKGROUND_COLOR: '#CFE3FF',
};

export const DIVISION_COLORS: { [key: string]: string } = {
  '19.00': REPORT_COLORS.GREEN,
  '20.00': REPORT_COLORS.GREEN,
};

export const HEIGHTS = {
  FOOTER_HEIGHT: '70px',
  SUBTOTAL_HEIGHT: 50,
  MAX_TABLE_HEIGHT: 400,
  MIN_TABLE_HEIGHT: 180,
  EXTRA_ROW_SPACING: 52,
};

export const WIDTHS = {
  COMPS_TABLE_WIDTH: 500,
  DIVSION_TABLE_WIDTH: 400,
};

export const TOTAL_ID = 'total';

export const TOTALS_DIVISIONS = {
  HARD_COSTS_START_INDEX: 0,
  HARD_COSTS_END_INDEX: 15,
  CONTRACTOR_OVERHEAD_INDEX: 16,
  CONTRACTOR_CONTINGENCY_INDEX: 17,
  SOFT_COSTS_START_INDEX: 18,
  SOFT_COSTS_END_INDEX: 19,
} as const;

export const ALLOWANCES_TOTAL_ID = 'allowances total';

// Reusable page keys for user preferences
export const PAGE_KEYS = {
  PROJECTS_LIST: 'projects-list',
  PAYAPP_PROCESS: 'payapp-process',
} as const;
